export const locales = [
    {
        locale: 'English',
        localeId: 'en'
    },
    {
        locale: 'French',
        localeId: 'fr'
    },
    {
        locale: 'Spanish',
        localeId: 'es'
    }
];
